import * as React from 'react';
import classNames from 'classnames';

function Chevron(_a) {
    var direction = _a.direction, className = _a.className, _b = _a.isEnabled, isEnabled = _b === void 0 ? true : _b;
    return (React.createElement("div", { className: classNames("nv-icon--".concat(direction), className) },
        React.createElement("svg", { height: "12", viewBox: "0 0 21 12", width: "21", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
                React.createElement("g", { fill: isEnabled ? '#128279' : '#a8aab3', transform: "translate(-169 -35)" },
                    React.createElement("g", { transform: "translate(169 34)" },
                        React.createElement("path", { d: "M2.195 1.53l8.211 8.211 8.213-8.21a1 1 0 011.32-.084l.094.083a1 1 0 010 1.415l-8.838 8.838a.998.998 0 01-.788.29.998.998 0 01-.788-.29L.78 2.945A1 1 0 112.195 1.53z" })))))));
}

export { Chevron as default };
//# sourceMappingURL=Chevron.esm.js.map
